import type { SignUpRequest, ApiError, RedirectResponse, SetupSignUpRequest } from '@/types';
import { ErrorService } from '@/error/error.service';
import { errorCodeOf, getJson, HttpError, postForm } from '@/utils/http';

export class SignUpService {
  public async getSignUpRequest(requestId: string | null): Promise<SignUpRequest | ApiError> {
    try {
      return await getJson<SignUpRequest>(`/sign-up/${requestId}`);
    } catch (e) {
      return ErrorService.getError('ibis', errorCodeOf(e));
    }
  }

  public async getSetupForSignUp(requestId: string | null): Promise<SetupSignUpRequest | ApiError> {
    try {
      return await getJson<SetupSignUpRequest>(`/sign-up/setup/${requestId}`);
    } catch (e) {
      const errorCode = errorCodeOf(e);
      if (errorCode) {
        return ErrorService.getError('ibis', errorCode);
      }

      if (e instanceof HttpError && e.data) {
        return ErrorService.getError('ibis', e.data);
      }

      return ErrorService.getGenericError();
    }
  }

  public async sendSignUpRequest(
    requestId: string,
    formData: string,
  ): Promise<RedirectResponse | ApiError> {
    try {
      return await postForm<RedirectResponse>(`/sign-up/${requestId}/validate`, formData);
    } catch (e) {
      if (e instanceof HttpError && e.data) {
        return ErrorService.getError('ibis', errorCodeOf(e));
      }

      return ErrorService.getGenericError();
    }
  }

  public async cancelSignUp(requestId: string): Promise<RedirectResponse | ApiError> {
    try {
      return await postForm<RedirectResponse>(`/sign-up/${requestId}/signup`);
    } catch (e) {
      if (e instanceof HttpError && e.data) {
        return ErrorService.getError('ibis', errorCodeOf(e));
      }

      return ErrorService.getGenericError();
    }
  }
}
